import React from "react";
import { Box, Container, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import logoUrl from "../assets/images/logo-svg2.svg";

function Footer() {
  return (
    <>
      {/* Primeira parte do rodapé com a logo e os links */}
      <Box sx={{ bgcolor: "#414141", color: "#fff", p: 3 }}>
        <Container
          maxWidth="lg"
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" }, // Coluna em xs, linha em sm e acima
            justifyContent: "space-between",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              width: "auto",
              height: "60px",
              marginBottom: { xs: "16px", sm: "0px" },
            }}
          >
            <img
              src={logoUrl}
              alt="Logo"
              style={{ width: "100%", height: "100%" }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "flex-end",
              alignItems: "center",
              width: { xs: "100%", sm: "auto" }, // 100% de largura no mobile para centralizar os links
            }}
          >
            <Link
              href="/privacy-policy"
              sx={{
                color: "#fff",
                fontSize: "15px",
                mb: { xs: 2, sm: 0 },
                mr: { sm: 2 },
                fontFamily: "Montserrat"
              }}
              underline="none"
            >
              Política de privacidade
            </Link>
            <Link
              component={RouterLink}
              to="/vitrine"
              sx={{
                color: "#fff",
                fontSize: "15px",
                mb: { xs: 2, sm: 0 },
                mr: { sm: 2 },
                fontFamily: "Montserrat",
              }}
              underline="none"
            >
              Serviços Extras
            </Link>

            <Link
              href="/fale-conosco"
              sx={{ color: "#fff", fontSize: "15px", mb: { xs: 2, sm: 0 }, fontFamily: "Montserrat" }}
              underline="none"
            >
              Entre em contato
            </Link>
          </Box>
        </Container>
      </Box>

      {/* Segunda parte do rodapé com o texto de copyright */}
      <Box sx={{ bgcolor: "#202020", color: "#fff", p: 1 }}>
        <Container maxWidth="lg"
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
          <Typography align="center" sx={{ fontSize: "12px" }}>
            © Copyright 2023 - WASH.APP. Todos os direitos reservados.
          </Typography>

          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row' },
            alignItems: { xs: 'flex-start', sm: 'flex-start', md: 'center', lg: 'center' },
            marginTop: { xs: '8px', sm: '8px', md: 0, lg: 0 },
            width: { xs: '100%', sm: '100%', md: 'auto', lg: 'auto' }
          }}>
            <Typography align="center" sx={{ fontSize: "11px" }}>
              Wash Serviços De Tecnologia Ltda. |
            </Typography>
            &nbsp;
            <Typography align="center" sx={{ fontSize: "11px" }}>
              CNPJ 52.472.237/0001-79
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
}

export default Footer;
